$(document).ready(function () {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const $emailInput = $("#form-check-warranty input");
    const $validateMessage = $('#form-check-warranty .validate-message');

    $(".section-result h1").click(function (){
        $emailInput.val("");
        $(".section-check").show();
        $(".section-result.found").hide();
        $(".section-result.not-found").hide();

    })

    $("#form-check-warranty").submit(function () {
        $validateMessage.html('');
        let email = $emailInput.val();
        if (!email) {
            $validateMessage.html('E-mail Address is required.');
            $emailInput.focus();
            return false;
        }
        if (!emailPattern.test(email)) {
            $validateMessage.html('Invalid email.');
            $emailInput.focus();
            return false;
        }
        $("#records").html("");
        $.ajax({
            url: `https://user.supcase.com/prod-api/supcase/warranty/check-warranty`,
            type: 'GET',
            contentType: 'application/json',
            data: {email: email},
            success: function (res) {
                $(".section-check").hide();
                if (res.code == 200 && res.data && res.data.length > 0) {
                    res.data.forEach((item, index) => {
                        $("#records").append(`<div class="record-title"><span>Record ${index+1}</span></div>`);
                        $("#records").append(`<p> Your extended warranty registration was completed on <b>${item.submitDate}</b>. <br> The warranty coverage period for your product is: <b>${item.warrantyStartDate}</b> – <b>${item.warrantyEndDate}</b>. </p> `);
                    })
                    $(".section-result.found").show();
                } else {
                    $(".section-result.not-found").show();
                }
            }
        });

        return false;
    });

});